import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { path } from 'ramda';

import Card from '../../../../components/Card';
import { routes } from '../../../index';
import { Link } from 'react-router-dom';

const mapStore = ({ user }) => ({ extensions: user.extensions });

const propTypes = {
  extensions: PropTypes.array,
};

const Extensions = ({ extensions }) => (
  <div>
    <div className="row">
      <div className="col">
        <Card>
          <Card.Header compact>
            Extensions
            <Link className="btn btn-primary float-right" to={routes.certificationsAndTraining.extension.request}>
              Request
            </Link>
          </Card.Header>
          <Card.Body>
            {extensions.length > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    <th>Program</th>
                    <th>Type</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {extensions.map((extension) => {
                    const isRegistration = extension.category.step;
                    const name = isRegistration
                      ? path(
                          ['category', extension.category.trainingId ? 'training' : 'certification', 'name'],
                          extension,
                        )
                      : path(['category', 'name'], extension);

                    return (
                      <tr key={extension.id}>
                        <td>{name}</td>
                        <td>{isRegistration ? 'Registration' : 'Certification'}</td>
                        <td>{extension.approved == null ? 'Pending' : extension.approved ? 'Approved' : 'Rejected'}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <p>You do not have any extensions yet.</p>
            )}
          </Card.Body>
        </Card>
      </div>
    </div>
  </div>
);

Extensions.propTypes = propTypes;

export default connect(mapStore)(Extensions);
